<template>
  <v-container>
    <DataTable
      :headers="headers"
      :values="values"
      :sortby="sortby"
      :sortdesc="sortdesc"
      dense
      @onAuthChange="onAuthChange"
      @onClubChange="onClubChange"
    >
    </DataTable>
    <Snack
      ref="snackbar"
      :message="snackBar.message"
      :barColor="snackBar.barColor"
      :timeout="snackBar.timeout"
    ></Snack>
  </v-container>
</template>
<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import store from "../../stores";
import { db } from "../../plugins/firebase";
import firebase from "../../plugins/firebase";
import moment from "moment";
import DataTable from "@/components/Table/SAUser.vue";
import JamConst from "@/mixins/JamConst.js";
import CommonMethods from "@/mixins/CommonMethods.js";
import Snack from "@/components/Alert/Snackbar";

export default {
  name: "admin-users",
  mixins: [JamConst, CommonMethods],
  components: {
    DataTable,
    Snack,
  },
  mounted(){
    this.checkState();
  },
  watch: {
    async users() {
      // mapで非同期を実行する
      this.values = await Promise.all(
        this.users.map(async (n) => {
          // 権限のオブジェクト作成
          var state = {};
          state.id = n.state;
          switch (n.state) {
            case 0:
              state.auth = "Super Admin";
              break;
            case 1:
              state.auth = "Admin";
              break;
            case 2:
              state.auth = "User";
              break;
            case 3:
              state.auth = "Kids";
              break;
            default:
              state.auth = "Unknown";
              break;
          }
          n.state = state;
          // YHBC会員のオブジェクト作成
          const result = await db
            .collection("club_users")
            .where("uid", "==", n.uid)
            .get();
          n.isYhbc = !result.empty ? true : false;
          return n;
        })
      );
    },
  },
  data() {
    return {
      sharedState: store.state,
      headers: [
        { text: "会員番号", sortable: true, value: "number" },
        {
          text: "名前",
          align: "left",
          sortable: true,
          value: "name",
        },
        { text: "名前(カナ)", value: "name_kana" },
        { text: "ニックネーム", value: "displayName" },
        { text: "生年月日", value: "birthday" },
        { text: "権限", value: "state" },
        { text: "YHBC会員", value: "isYhbc" },
      ],
      sortby: ["number", "state"],
      sortdesc: [false, true],
      users: [],
      values: [],
      snackBar: {
        message: "",
        barColor: "success",
      },
      isSnack: false,
    };
  },
  methods: {
    onClubChange(item) {
      try {
        if (item.isYhbc) {
          db.collection("club_users").add({ uid: item.uid });
          this.snackBar.message = "会員にしました！";
          this.snackBar.barColor = "success";
        } else {
          db.collection("club_users")
            .where("uid", "==", item.uid)
            .limit(1)
            .get()
            .then((docs) => {
              if (docs.empty) return;
              docs.forEach((n) => {
                db.collection("club_users")
                  .doc(n.id)
                  .delete();
              });
            });
          this.snackBar.message = "会員から除外しました！";
          this.snackBar.barColor = "success";
        }
      } catch (err) {
        this.snackBar.message = err.message;
        this.snackBar.barColor = "error";
      } finally {
        this.$refs.snackbar.show();
      }
    },
    async onAuthChange(item) {
      console.log(item);
      // 更新前のチェック
      if (!this.preCheck(item)) return;
      try {
        // stateプロパティのみを更新
        await db
          .collection("M_USER")
          .doc(item.id)
          .set({ state: item.state }, { merge: true });
        this.snackBar.message = "権限を更新しました！";
        this.snackBar.barColor = "success";
      } catch (err) {
        this.snackBar.message = err.message;
        this.snackBar.barColor = "error";
      } finally {
        this.$refs.snackbar.show();
      }
    },
    preCheck(item) {
      if (item.state == 0) {
        this.dialog = true;
        return false;
      }
      return true;
    },
    async checkState() {
      await store.setUserAuth();
      if(!this.sharedState.user.isLogin) this.$router.push("/signin")
    }
  },
  firestore() {
    return {
      users: db.collection("M_USER"),
    };
  },
};
</script>
